import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

import faqFactory, { PublicVarsInterface as FaqSetupInterface } from '../../../../libs/faq/faq-service';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesFaqsFaqDisplayAllBtnCls: string;
			investorsResourcesFaqsFaqItemCls: string;
			investorsResourcesFagsFaqWrapperCls: string;
		}
	},

	faqSetup?: FaqSetupInterface

	slug: string
}

class Faq extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Faqs Faq Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.faqSetup) {
			this.errorMsg('faqSetup is not defined');
		} else {
			const faq = faqFactory.create();
			faq.init(this.publicVars.faqSetup);
		}

		//BTODO gsap memoizes position so when faq item is opened it changes vertical size causing errors - improper position trigerring gsap scroll effects
		//after changing layout all setup that is below should be invalidated and recalculated
		/*
		document.querySelector("#invalidate").addEventListener("click", function() {
		  t.invalidate();
		  t.restart();
		});
		 */

		scroll.init();
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '1', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '2', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '3', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '4', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '5', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '6', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '7', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '8', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '9', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '10', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '11', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '12', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqItemCls + '13', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn'});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFagsFaqWrapperCls || '', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesFaqsFaqDisplayAllBtnCls || '', 'investors_resources_faqs_faq', { animCls: 'animate__fadeIn', once: true});


	}

	bind() {
		this.msg('bind');
	}
}

export default Faq;